const ExpandedOrCollapsed = {
  EXPANDED: "expanded",
  COLLAPSED: "collapsed"
} as const;

const ALL = Object.values(ExpandedOrCollapsed);

export default { ...ExpandedOrCollapsed, ALL };
